import { useForm } from "react-hook-form"
import { CustomFormField } from "../../../../../utilis/component/CustomFormElement"
import { IconButton, Table, TableCell, TableHead, TablePagination, TableRow } from "@mui/material"
import CustomTableBody from "../../../../../utilis/component/CustomTableBody"
import {  useEffect, useState } from "react"
import { useMutation } from "react-query"
import moment from "moment"
import {  NoteAdd } from "@mui/icons-material"
import debounce from "../../../../../utilis/methods/networkHandling"
import { FormOnChangeEventType } from "../../../../../EMR/types"
import { useNavigate } from "react-router-dom"
import { base } from "../../../../../constants"
import moduleRoutes from "../../../../../routes/moduleRouteList"
import patientCareRouteList from "../../../../routeList"
import {  billedItemType, getbilledItemPayloadType } from "../../type"
import { getBilledItemService } from "../../Service"
import useAuthentication from "@hooks/useAuthentication"
const CashierList = () => {
    const {control}=useForm()
    const navigateTo=useNavigate()
    const [billedList,setBilledList]=useState<any>([])
    const [searchPayload, setSearchPayload] = useState<getbilledItemPayloadType>({
        filter: {
          search: "",
          searchDate: moment().format("YYYY-MM-DD"),
        },
        pageNumber: 1,
        pageSize: 25,
        sortField: "",
        sortOrder: "asc",
      })
      const {mutate:getBilledList,isLoading}=useMutation(getBilledItemService,{onSuccess:(data)=>{
          console.log(data);
          setBilledList(data)
      }})
      useEffect(()=>{
        getBilledList(searchPayload)
      },[searchPayload])

      const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        const pageSize = parseInt(event.target.value, 10)
        setSearchPayload((prev)=>({
            ...prev,
            pageNumber:1,
            pageSize
        }));
      };
      const handleChangePage = (_: unknown, newPage: number) => {
  setSearchPayload((prev) => ({
    ...prev,
    pageNumber: newPage + 1, // backend expects 1-based page number
  }));
};

     const searchOnText =  debounce((e:FormOnChangeEventType) => {
      console.log(e.target.value);
      
      setSearchPayload(prev=>({
        ...prev,
        filter:{
          ...prev.filter,
          [e.target.name]:e.target.value
        }
      }))
      }, 500)
    const searchAppointments =  (e:FormOnChangeEventType) => {
      setSearchPayload(prev => {
        const { filter } = prev;
        const { name, value } = e.target;
        
        const newValue = name === "searchDate" 
          ? value 
          : (value?.id === 2 ? null : value?.id);
      
        return {
          ...prev,
          filter: {
            ...filter,
            [name]: newValue
          }
        };
      })
   }
      

     const{user}= useAuthentication();
 const regionValue= user?.region;
   const idHeading =
  regionValue === "QATAR_REGION"
    ? "Qatar ID"
    : "Emirates Id";


const headings=[
    "sl No",
  "EMR No/Reg No",
    "Patient Name",
    idHeading,
    "BilledDate",
    "Action"
]
   
  return (
    <>
       <form >
            <div className="grid grid-cols-12 gap-2 my-2">
                   <div className="col-span-2"> 
                        <CustomFormField 
                        control={control}
                        element="input"
                        name="search"
                        rules={{required:false,onChange:searchOnText}}
                        fieldProps={{label:"search", type:"text"}}
                        />
                   </div>
                   <div className="col-span-2">
                        <CustomFormField 
                        control={control}
                        element="datepicker"
                        name="searchDate"
                        dateFormat="YYYY-MM-DD"
                        rules={{required:false ,onChange:searchAppointments}}
                        fieldProps={{label:""}}
                        />
                   </div>
                   <div className="col-span-2">
            <CustomFormField
              control={control}
              element="autocomplete"
              options={[
                { id: 2, name: "All" },
                { id: 1, name: "Insurance" },
                { id: 0, name: "Cash" },
              ]}
              autocompleteProps={{
                getOptionLabel: (option) => option?.name || "",
                isOptionEqualToValue: (option, value) => {
                  if (!value) return false;
                  return option?.id === value?.id;
                },
              }}
              name="type"
              rules={{ required: false, onChange: searchAppointments }}
              fieldProps={{ label: "Payment Type" }}
            /></div>
            </div>
       </form>
        <Table size="small">
            <TableHead   sx={(theme) => ({ backgroundColor: theme.palette.primary.main})}>
                <TableRow>
                     {
                        headings.map((item:string)=>{
                            return (
                                <TableCell  key={item} sx={(theme) => ({  color: theme.palette.background.paper})}  >
                                {item}
                               </TableCell>
                            )
                        })
                     }
                </TableRow>
            </TableHead>

           <CustomTableBody alert={"No Billed Items"} dataLoading={isLoading} isData={Boolean(billedList?.response?.items?.length)} totalSpan={{col:headings.length,row:searchPayload.pageSize}}>
                       {
                          billedList?.response?.items?.map((item:billedItemType,index:number)=>{
                            return(
                          <TableRow key={item.billingId}>
                             <TableCell>
  {(searchPayload.pageNumber - 1) * searchPayload.pageSize + (index + 1)}
</TableCell>

                              <TableCell >
                              {item.patientID}
                             </TableCell>
                              <TableCell >
                              {item.patientName}
                             </TableCell>
                              <TableCell >
                              {item?.emiratesID}
                             </TableCell>
                              <TableCell >
                              {item?.createdDate}
                             </TableCell>
                             <TableCell >
                                  <IconButton onClick={()=>  {
                                    navigateTo(`${base}${moduleRoutes.mainRoute}/${moduleRoutes.patientCare}/${patientCareRouteList.paymentv1}/${item.billingId}/${item.encounterID}/${item.patientMasterID}?emrno=${item.patientID}`)
                                    console.log(`${base}${moduleRoutes.mainRoute}/${moduleRoutes.patientCare}/${patientCareRouteList.paymentv1}/${item.billingId}/${item.encounterID}/${item.patientMasterID}?emrno=${item.patientID}`)
                                  }} ><NoteAdd color="primary"/></IconButton>
                             </TableCell>
                          </TableRow>
                            )
                          })
                       }
            </CustomTableBody>  
        </Table>
        <TablePagination
  count={billedList?.response?.totalCount || 0}
  rowsPerPageOptions={[5, 10, 25]}
  component="div"
  onPageChange={handleChangePage}
  onRowsPerPageChange={handleChangeRowsPerPage}
  rowsPerPage={searchPayload.pageSize}
  page={(searchPayload.pageNumber || 1) - 1} // convert to 0-based
/>

    </>
  )
}

export default CashierList




